var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1,
    fill: "#272932"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.5L11.8586 5.14142C11.9367 5.06332 12.0633 5.06332 12.1414 5.14142L13.5 6.5",
    stroke: "#272932",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13.5L5.14142 12.1414C5.06332 12.0633 5.06332 11.9367 5.14142 11.8586L6.5 10.5",
    stroke: "#272932",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 17.5L12.1414 18.8586C12.0633 18.9367 11.9367 18.9367 11.8586 18.8586L10.5 17.5",
    stroke: "#272932",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.5L18.8586 11.8586C18.9367 11.9367 18.9367 12.0633 18.8586 12.1414L17.5 13.5",
    stroke: "#272932",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.2261cb2bf48cea78a434e1afc39ec843.svg";
export { ForwardRef as ReactComponent };